{
  "feedbackTextInputLabel": "Comparte tus pensamientos",
  "feedbackTextInputPlaceholder": "Quería compartir algunos comentarios...",
  "likeOrDislikeWithFeatureName": "¿Te gusta el {{featureName}}?",
  "linkTo": "Compartir comentarios",
  "other": "Otra cosa",
  "subjectTextInputLabel": "Sujeto",
  "subjectTextInputPlaceholder": "(Elegir tema)",
  "successMessage": "Hemos recibido sus comentarios.",
  "description": "Nos encantaría conocer tu opinión sobre cómo podemos mejorar nuestro producto.",
  "title": "Compartir comentarios"
}
